(function () {
    'use strict';

    angular.module('sdhApp.pageSelect', []).directive('pageSelect', pageSelect);

    pageSelect.$inject = [];

    function pageSelect() {

        var directive = {
            restrict: 'EA',
            scope: {
                placeholder: "=placeholder",
                model: "=model",
                options: "=options"
            },
            templateUrl: 'page-select.html',
            controller: PageSelectController,
            controllerAs: 'ctrl',
            bindToController: true
        };

        return directive;
    }

    PageSelectController.$inject = ["$scope"];
    
    function PageSelectController($scope) {
        var vm = this;
        vm.showOptions = false;

        vm.setValue = function(model) {
            vm.model = model * 1;

            vm.showOptions = false;
            vm.hasValue = true;
        }
    };



})();


